import Vue from "vue";
import Murmur from "@icij/murmur";
Vue.use(Murmur);
Murmur.config.set("project.name", "Cyprus Confidential");
Murmur.config.set("app.name", "Providers of Secrecy");
Murmur.config.set(
  "app.home",
  "https://www.icij.org/investigations/cyprus-confidential/service-providers-cyprus-leak"
);
